/* Repair known UTF-8 emoji misdecoding in the embedded review display. */
(function () {
  var attached = new WeakSet();
  function repair(root) {
    var walker = root.ownerDocument.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (/^(SCRIPT|STYLE|TEXTAREA)$/.test(node.parentElement && node.parentElement.tagName)) continue;
      var fixed = node.nodeValue
        .replace(/\u00f0\u0178\u02dc\u0160/g, '\u{1F60A}')
        .replace(/\u00f0\u0178\u02dc\u008d/g, '\u{1F60D}');
      if (fixed !== node.nodeValue) node.nodeValue = fixed;
    }
  }
  function connect(frame) {
    function ready() {
      try {
        var doc = frame.contentDocument;
        if (!doc || !doc.body || attached.has(doc)) return;
        attached.add(doc);
        repair(doc.body);
        new MutationObserver(function () { repair(doc.body); })
          .observe(doc.body, { childList:true, subtree:true, characterData:true });
      } catch (_) { /* Cross-origin widgets remain untouched. */ }
    }
    frame.addEventListener('load', ready);
    ready();
  }
  var frames = new WeakSet();
  function scan() {
    document.querySelectorAll('iframe.scm-reviews-importer-iframe').forEach(function (frame) {
      if (!frames.has(frame)) { frames.add(frame); connect(frame); }
    });
  }
  scan();
  new MutationObserver(scan).observe(document.body, {childList:true, subtree:true});
})();
